import { Mapper } from '@core/model/framework/mapper';
import { inject, injectable } from 'inversify';
import { BankConnection } from '@core/model/domain/bankConnection';
import { BankConnectionLinkedNotificationDto } from '@core/service/digital-factory/bank/types/dto/bankConnectionDto';
import { BankConnectionStateMapper } from './bankConnectionStateMapper';

@injectable()
export class BankConnectionLinkedNotificationMapper
  implements Mapper<BankConnection, BankConnectionLinkedNotificationDto>
{
  constructor(
    @inject(BankConnectionStateMapper)
    private readonly bankConnectionStateMapper: BankConnectionStateMapper
  ) {}

  toDomain(notification: BankConnectionLinkedNotificationDto): BankConnection {
    return {
      bankId: notification.bankId,
      connectionId: notification.connectionId,
      state: this.bankConnectionStateMapper.toDomain(notification.state),
      lastSynchronizedAt: null,
    };
  }
}
